/* eslint-disable @repo/internal/react/require-jsdoc */

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { gridSize } from '@atlaskit/theme/constants';
var fixedHeightStyles = css({
  height: "".concat(gridSize() * 18, "px")
});
export var EmptyViewWithFixedHeight = function EmptyViewWithFixedHeight(_ref) {
  var children = _ref.children;
  return jsx("div", {
    css: fixedHeightStyles
  }, children);
};
var emptyViewContainerStyles = css({
  width: '50%',
  margin: 'auto',
  padding: '10px',
  textAlign: 'center'
});
export var EmptyViewContainer = function EmptyViewContainer(_ref2) {
  var children = _ref2.children;
  return jsx("div", {
    css: emptyViewContainerStyles
  }, children);
};